import { render } from "./CosmoRotateAllApps.vue?vue&type=template&id=615e2198&scoped=true"
import script from "./CosmoRotateAllApps.vue?vue&type=script&lang=js"
export * from "./CosmoRotateAllApps.vue?vue&type=script&lang=js"

import "./CosmoRotateAllApps.vue?vue&type=style&index=0&id=615e2198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615e2198"]])

export default __exports__